var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attrCard"},[_c('h3',[_vm._v(_vm._s(_vm.label))]),_c('p',[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"attrCard-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }